import { INTERNAL_KEY, INTERNAL_VALUE } from '../config/internal'

export const checkInternalInUrlParams = () => {
	const params = new URL(document.location.toString()).searchParams
	const internal = params.get(INTERNAL_KEY)

	return internal === INTERNAL_VALUE
}
